import { libVotingPolicy } from '@tumelo/common/'
import { VotingPolicy } from '../../proto/tumelo/stewardshipbff/v1/voting_policy'

export const sampleVotingPolicy = (): VotingPolicy =>
  VotingPolicy.fromPartial({
    name: libVotingPolicy.IDToName({ votingPolicyID: 'f9f4668a-a625-465d-9e7c-c9179e674f1c' }),
    title: 'Glass Lewis Policy 1',
    policyDocumentUrl: 'https://example.com/',
  })

export const SampleVotingPolicy = (override: Partial<VotingPolicy> = {}): VotingPolicy => {
  const init = VotingPolicy.fromPartial({
    name: `votingPolicies/${override.titleAbbreviation?.toLowerCase().replace(/\s+/g, '-') || 'default'}`,
    title: `${override.titleAbbreviation || 'Default'} Voting Policy`,
    titleAbbreviation: 'Default',
    policyDocumentUrl: 'https://example.com/policy.pdf',
    automaticVoting: false,
  })
  return { ...init, ...override }
}
